// extracted by mini-css-extract-plugin
export var addToCartButton = "_o5-b";
export var arrowButtonContainer = "_o5-9";
export var arrowButtonIcon = "_o5-a";
export var carouselArrowButton = "_o5-6";
export var carouselElementContainer = "_o5-1";
export var left = "_o5-7";
export var productDisplayCarouselContainer = "_o5-0";
export var productTileContainer = "_o5-2";
export var productTileImage = "_o5-4";
export var productTileImageContainer = "_o5-3";
export var productTileTitle = "_o5-5";
export var right = "_o5-8";
export var sliderOverflow = "_o5-c";